import _ from 'underscore';
import { I18nModel } from '@bingads-webui-universal/i18n-model';
import { getFailFastSetting } from './fail-fast-setting';
import { ILegacyI18n } from './types';

const mergeLegacyStrings = (legacyI18ns: ILegacyI18n[]): Record<string, string> => _.reduce(legacyI18ns, (legacyStrings, i18n) => ({
  ...legacyStrings,
  ...i18n.getData(),
}), {});

export const mergeLegacyI18ns = (legacyI18ns: ILegacyI18n[]): I18nModel => {
  // All i18n passed should logically use the same timeZone and currency
  const { timeZone, currency } = legacyI18ns[0];
  return new I18nModel({
    timeZone,
    currency,
    loadTranslationData: () => mergeLegacyStrings(legacyI18ns),
    loadCLDRData: (locale: string) => locale,
    failFast: getFailFastSetting(),
  });
};
